import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import { useMemo } from 'react';

/**
 * Whether to show free trial content: the trial is only offered while the current subscription is the shop's first one.
 */
export const useShowFreeTrial = (): boolean => {
    const { allSubscriptions } = useCurrentSubscriptionHelper();

    return useMemo(() => allSubscriptions.length === 1, [allSubscriptions]);
};
